<div class="project-create-page page">
    <main class="project-create-page__content content">

        <header>
            <div class="page-title">Create Project</div>
            <div class="page-subtitle">Create a new ECHO project</div>
        </header>

        <section class="project-create-page__section-content input-container">
            <div class="project-create-page__section-title">Project details</div>

            <div>Enter some details about your project</div>

            <dds-input [formControl]="inputFormCtrl" [label]="inputOptions.label"
                [labelPosition]="inputOptions.labelPosition" [placeholder]="inputOptions.placeholder"
                [isRequired]="inputOptions.isRequired" [isInverse]="inputOptions.isInverse"
                [isError]="inputOptions.isError" [readonly]="inputOptions.readonly" [size]="inputOptions.size"
                [description]="inputOptions.description" [errorMessage]="inputOptions.errorMessage"
                [errorState]="inputOptions.errorState" [descriptionType]="inputOptions.descriptionType"
                [maxLength]="inputOptions.maxLength" [maxLengthPosition]="inputOptions.maxLengthPosition"
                [textAlign]="inputOptions.textAlign" [type]="inputOptions.type" (valueChanged)="changeValue()"
                (onBlur)="onBlur()"></dds-input>

            <dds-textarea [formControl]="textareaFormCtrl" [label]="textareaOptions.label"
                [labelPosition]="textareaOptions.labelPosition" [placeholder]="textareaOptions.placeholder"
                [description]="textareaOptions.description" [minHeight]="textareaOptions.minHeight"
                [isRequired]="textareaOptions.isRequired" [isInverse]="textareaOptions.isInverse"
                [isError]="textareaOptions.isError" [errorMessage]="textareaOptions.errorMessage"
                [errorState]="textareaOptions.errorState" [maxLength]="textareaOptions.maxLength"
                [maxLengthPosition]="textareaOptions.maxLengthPosition" [size]="textareaOptions.size"
                [readonly]="textareaOptions.readonly" (valueChanged)="descriptionValueChanged()"></dds-textarea>
        </section>

        <section class="buttons-wrapper">
            <dds-button [theme]="cancelButtonOptions.theme" [kind]="cancelButtonOptions.kind"
                [size]="cancelButtonOptions.size" [width]="cancelButtonOptions.width" [icon]="cancelButtonOptions.icon"
                [isIconLeft]="cancelButtonOptions.isIconLeft" [role]="cancelButtonOptions.role"
                [isInverse]="cancelButtonOptions.isInverse" [isColorBg]="cancelButtonOptions.isColorBg"
                [isLoading]="cancelButtonOptions.isLoading" [ariaLabel]="cancelButtonOptions.ariaLabel"
                [customClass]="cancelButtonOptions.customClass" (clicked)="cancelClick($event)">Cancel</dds-button>

            <dds-button [theme]="createButtonOptions.theme" [kind]="createButtonOptions.kind"
                [size]="createButtonOptions.size" [width]="createButtonOptions.width" [icon]="createButtonOptions.icon"
                [isIconLeft]="createButtonOptions.isIconLeft" [role]="createButtonOptions.role"
                [isInverse]="createButtonOptions.isInverse" [isColorBg]="createButtonOptions.isColorBg"
                [isLoading]="createButtonOptions.isLoading" [ariaLabel]="createButtonOptions.ariaLabel"
                [customClass]="createButtonOptions.customClass" (clicked)="createProjectClick($event)">Create
                project</dds-button>
        </section>

    </main>
</div>